import React from 'react';
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';

export function MenuWidget1({ data }) {
  return (
    <ul className="cs_menu_widget cs_mp0">
      {data?.map((item, index) =>
        item.title === "Career" ? (
          <li>
            <a href="https://nhwm.in/career" rel="noopener noreferrer" target='_blank'>
              Career
            </a>
          </li>
        ) : (
          <li key={index}>
            <HashLink smooth to={`/${item.href}`}>{item.title}</HashLink>
          </li>
        )
      )}
    </ul>
  );
}

export function MenuWidget2({ data }) {
  return (
    <ul className="cs_menu_widget cs_mp0">
      {data?.map((item, index) => (
        <li>
          <Link key={index} to={item.href}>{item.title}</Link>
        </li>
        )
      )}
    </ul>
  );
}
